import { render, staticRenderFns } from "./PageParticipantConsentLink.vue?vue&type=template&id=416dd5e8&scoped=true&"
import script from "./PageParticipantConsentLink.vue?vue&type=script&lang=ts&"
export * from "./PageParticipantConsentLink.vue?vue&type=script&lang=ts&"
import style0 from "./PageParticipantConsentLink.vue?vue&type=style&index=0&id=416dd5e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416dd5e8",
  null
  
)

export default component.exports